// This is intentionally a very lightweight function, any advanced
// validation can be handled with a more a modular regex file

export default function validateInput({ value, validationRegex }) {
  if (!value || value === "") {
    return false;
  }
  if (validationRegex?.test(value) === false) {
    return false;
  }
  return true;
}
